import { dialogs, i18next } from '@yola/ws-sdk';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';

const showInactiveTabSavingErrorDialog = () => {
  dialogs.operations.show(dialogTypes.ALERT_DIALOG, {
    glyph: 'alert-circle',
    width: 334,
    height: 'auto',
    captions: {
      title: i18next.t('Unable to save changes'),
      description: i18next.t(
        'We couldn’t save your changes in the inactive tab. Please switch to that tab, save your work, and try again.'
      ),
      dismiss: i18next.t('Got it'),
    },
    onDismiss: () => {
      dialogs.operations.hide();
    },
  });
};

export default showInactiveTabSavingErrorDialog;
